import React from "react";
import {observer} from "mobx-react";
import {useRequiredStore} from "../../../utils/store";
import {RootStoreContext} from "../../../stores/root/root.store";
import {Modal} from "antd";

export const Confirmation: React.FC = observer(() => {

    const {confirmStore} = useRequiredStore(RootStoreContext)

    if (!confirmStore.shown) {
        return null;
    }

    return (
        <Modal
            title={"Warning"}
            visible
            onOk={() => confirmStore.success()}
            onCancel={() => confirmStore.close()}
            okButtonProps={{disabled: confirmStore.disabled}}
            cancelButtonProps={{disabled: confirmStore.disabled}}
        >
            {confirmStore.message}. Continue?
        </Modal>
    )
});